import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TaxListLayer from "../components/TaxListLayer";

const TaxListPage = () => {
    return (
        <MasterLayout>
            <TaxListLayer />
        </MasterLayout>
    );
};

export default TaxListPage;
